import { render } from "./ModalFlag.vue?vue&type=template&id=031798b4"
import script from "./ModalFlag.vue?vue&type=script&lang=js"
export * from "./ModalFlag.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__